import React from 'react';

/**
 * Typography — one scale used everywhere so headings, body and labels look
 * identical across the platform.
 *
 *   <Heading level={1}>Clients</Heading>
 *   <Text variant="body">All clients and their details.</Text>
 *   <Text variant="label" as="span">Address</Text>
 */

const HEADING = {
  1: 'text-[28px] font-extrabold tracking-[-0.8px] leading-tight',
  2: 'text-[22px] font-bold tracking-[-0.5px] leading-tight',
  3: 'text-[16px] font-bold tracking-[-0.2px]',
};

export const Heading = ({ level = 2, as, className = '', children, ...rest }) => {
  const Tag = as || `h${level}`;
  return (
    <Tag className={`text-[#0B1220] dark:text-gray-100 ${HEADING[level] || HEADING[2]} ${className}`} {...rest}>
      {children}
    </Tag>
  );
};

const TEXT = {
  body: 'text-[13.5px] font-normal text-[#334155] dark:text-gray-300',
  strong: 'text-[13.5px] font-semibold text-[#0B1220] dark:text-gray-100',
  label: 'text-[11px] font-bold uppercase tracking-[0.06em] text-[#64748B] dark:text-gray-400',
  caption: 'text-[12px] font-medium text-[#94A3B8] dark:text-gray-500',
  link: 'text-[13.5px] font-semibold text-blue-600 hover:text-blue-700 cursor-pointer',
};

export const Text = ({ variant = 'body', as = 'span', className = '', children, ...rest }) => {
  const Tag = as;
  return (
    <Tag className={`${TEXT[variant] || TEXT.body} ${className}`} {...rest}>
      {children}
    </Tag>
  );
};
